import { __decorate } from "tslib";
import { inject } from '@angular/core';
import { CompanyClientStatus } from '@common/users/shared';
import { AccessState, provideFeatureAddonRoutes } from '@core/frontend-shared';
import { FrontendFeaturePlugin } from '@core/frontend-shared/feature';
import { UserRole } from '@core/shared/access';
import { ClassName } from '@core/shared/class-name';
import { Store } from '@ngxs/store';
import { UsersDemoStartOverlayComponent } from './demo/demo-start.component';
import { DynamicDialogService } from '@common/ui/frontend-shared/dynamic-dialog';
import { UserConvertComponent } from './user/user-convert/user-convert.component';
import * as i0 from "@angular/core";
let UsersFrontendManagementFeature = /*#__PURE__*/(() => {
  let UsersFrontendManagementFeature = class UsersFrontendManagementFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/users/frontend-management","featureId":"common-users"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineRootComponents([{
        component: UsersDemoStartOverlayComponent
      }]);
      functionality.defineMenuItems({
        managementToolbar: {
          basePath: 'management',
          items: [{
            priority: 10,
            label: 'Mitarbeiterverwaltung',
            icon: 'users',
            simpleAbilityCheck: "Programmatic.common-users.IsCompanyManager",
            routerLink: 'users'
          },
          // using access check so that managementToolbar will stay empty for basic users, resulting in not showing it at all.
          {
            priority: -5,
            label: 'Mein Profil',
            icon: 'user',
            routerLink: 'profile',
            simpleAbilityCheck: UserRole.MANAGER
          }]
        }
      });
      functionality.defineRouterLinkRedirects([{
        matcher: '/user/profile',
        redirect: '/management/profile',
        type: 'Replace',
        simpleAbilityCheck: UserRole.MANAGER
      }]);
      functionality.defineWidgets([{
        type: 'Dashboard',
        id: 'UsersTeamManagementShortcutsWidget',
        priority: 20,
        name: 'Teamverwaltung',
        defaultVisibility: 'show',
        dashboardIds: ['management'],
        simpleAbilityCheck: ['MANAGER'],
        load: () => import('./widgets/team-management.widget').then(m => m.UsersTeamManagementShortcutsWidget),
        config: {}
      }, {
        type: 'Dashboard',
        id: 'UsersDemoStatusWidget',
        priority: 21,
        name: 'Ihre Demo',
        defaultVisibility: 'show',
        visibility: () => {
          const demo = inject(Store).selectSnapshot(AccessState.accessData('demo'));
          const company = inject(Store).selectSnapshot(AccessState.accessData('company'));
          return () => {
            return demo && company?.clientStatus !== CompanyClientStatus.Contracted;
          };
        },
        wrapper: false,
        dashboardIds: ['management'],
        simpleAbilityCheck: ['MANAGER'],
        load: () => import('./widgets/demo-status.widget').then(m => m.UsersDemoStatusWidget),
        config: {}
      }]);
      functionality.defineItemActions([{
        modelId: 'UserItem',
        displayContext: ['admin', 'crud'],
        label: 'Zu Manager konvertieren',
        icon: "exchange-alt",
        // enableIf:(item) => { 
        // 	return item.email
        // },
        action: item => {
          inject(DynamicDialogService).open(UserConvertComponent, {
            header: 'Zu Manager konvertieren',
            width: '500px',
            contentStyle: {
              "overflow": "auto"
            },
            baseZIndex: 10000,
            padded: false,
            // closeOnEscape:true,
            // dismissableMask:true,
            // maximizable: true,
            data: {
              user: item
            }
          });
        }
      }]);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵUsersFrontendManagementFeature_BaseFactory;
        return function UsersFrontendManagementFeature_Factory(__ngFactoryType__) {
          return (ɵUsersFrontendManagementFeature_BaseFactory || (ɵUsersFrontendManagementFeature_BaseFactory = i0.ɵɵgetInheritedFactory(UsersFrontendManagementFeature)))(__ngFactoryType__ || UsersFrontendManagementFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: UsersFrontendManagementFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideFeatureAddonRoutes([{
          useAddonSlot: 'management',
          path: 'users',
          loadChildren: () => import('./users-management.module').then(m => m.UsersFrontendManagementModule)
        }, {
          useAddonSlot: 'management',
          path: 'profile',
          loadChildren: () => import('@common/users/frontend/profile').then(m => m.UserProfileModule)
        }])]
      });
    }
  };
  UsersFrontendManagementFeature = __decorate([ClassName("UsersFrontendManagementFeature")], UsersFrontendManagementFeature);
  return UsersFrontendManagementFeature;
})();
export { UsersFrontendManagementFeature };